import React from 'react';
interface VignetteFrameProps {
  label: string;
  timestamp?: string;
  children: React.ReactNode;
}
export function VignetteFrame({
  label,
  timestamp,
  children
}: VignetteFrameProps) {
  return <div className="overflow-hidden rounded-2xl border border-white/10 bg-ink-800 shadow-2xl shadow-black/40" data-id="element-291" data-mp="1pf71e4scwz8f">
      <div className="flex items-center justify-between gap-4 border-b border-white/10 bg-ink-700 px-4 py-3" data-id="element-292" data-mp="1thk7iub0mz5q">
        <div className="flex items-center gap-2.5" data-id="element-293" data-mp="wscts8gn1ucd">
          <span className="flex gap-1.5" aria-hidden="true" data-id="element-294" data-mp="11q4m33l73ih3">
            <span className="h-2 w-2 rounded-full bg-white/15" data-id="element-295" data-mp="11qo0wbfjtqqw" />
            <span className="h-2 w-2 rounded-full bg-white/15" data-id="element-296" data-mp="15rgchbbw87qc" />
            <span className="h-2 w-2 rounded-full bg-white/15" data-id="element-297" data-mp="15u2gx23hm74c" />
          </span>
          <span className="text-xs font-semibold uppercase tracking-[0.14em] text-white/45" data-id="element-298" data-mp="1aopysi3zk39y">
            {label}
          </span>
        </div>
        {timestamp && <span className="text-xs font-medium tabular-nums text-white/35" data-id="element-299" data-mp="2m4oeh4to5nk5">
            {timestamp}
          </span>}
      </div>
      <div className="p-5 sm:p-6" data-id="element-300" data-mp="3cg3c8mfis136">{children}</div>
    </div>;
}